/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_QRC_CONFIGS_ITEM = {
  id: 'qr_configs',
  screenId: 'fin-qrc-configs',
  label: 'Agregar QR',
  description: 'Alta y edición de puntos de cobro QR.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Definís cada punto de cobro QR de tu negocio: en qué cuenta bancaria se acredita, qué porcentaje de comisión descontar y a qué costo imputar esa comisión.',
      },
      {
        title: 'Antes de empezar',
        paragraphs: [
          'Necesitás cuentas bancarias en Finanzas → Bancos.',
          'El «costo de fee» debe existir en el catálogo de costos (buscador al crear o editar).',
          'Quien crea una configuración queda autorizado a usarla en cobros.',
          'Opcional: podés vincular configuraciones QR a terminales de venta en Administración → Terminales de venta.',
        ],
      },
      {
        title: 'Lista',
        bullets: [
          'Columnas: ID, Descripción, Fee %, Activo.',
          'Tocá el lápiz de la fila para editar.',
          'Tocá otra parte de la fila para ver el detalle (solo lectura).',
        ],
      },
      {
        title: 'Alta de configuración',
        intro: 'El botón + abre «Nueva configuración QR». Campos:',
        fields: [
          { label: 'Descripción', description: 'Nombre interno (por ejemplo «QR mostrador principal»). Obligatoria.' },
          {
            label: 'Porcentaje de fee',
            description: 'Comisión que se descuenta del cobro (número positivo, por ejemplo 3,5). Obligatorio.',
          },
          {
            label: 'Costo de fee',
            description: 'Centro de costo donde se imputa la comisión. Buscá y elegí uno del listado. Obligatorio.',
          },
          {
            label: 'Cuenta bancaria',
            description: 'Cuenta donde se acredita el neto del cobro QR. Obligatoria.',
          },
        ],
        paragraphs: [
          'Tocá «Crear configuración» para guardar.',
        ],
      },
      {
        title: 'Editar',
        bullets: [
          'Podés cambiar descripción, porcentaje de fee, costo de fee y cuenta bancaria.',
          'Interruptor «Activo» — desmarcá para dejar de usar la configuración en cobros nuevos.',
        ],
      },
      {
        title: 'Cómo se usa al cobrar',
        paragraphs: [
          'En un recibo de cobro elegí medio «Cobro QR» y la configuración. Al confirmar, el sistema calcula fee = monto × porcentaje, acredita el neto en banco e imputa la comisión al costo configurado.',
        ],
      },
    ],
  },
}
